"use client";

import { useState, type Dispatch, type SetStateAction } from "react";

export function useSyncedState<Value>(
  source: Value,
): [Value, Dispatch<SetStateAction<Value>>] {
  const [value, setValue] = useState(source);
  const [lastSource, setLastSource] = useState(source);

  if (!Object.is(lastSource, source)) {
    setLastSource(source);
    setValue(source);
  }

  return [value, setValue];
}

export function useDepsChanged(deps: readonly unknown[]): boolean {
  const [lastDeps, setLastDeps] = useState(deps);

  if (
    lastDeps.length !== deps.length ||
    lastDeps.some((entry, index) => !Object.is(entry, deps[index]))
  ) {
    setLastDeps(deps);
    return true;
  }

  return false;
}
